import {
  ExclamationTriangle,
  Pen,
  Tasks,
  Users,
  Wrench,
  Cat,
  ListAlt,
  ClipboardList,
  SubmissionDraftsSolid,
  FileAlt,
  LinkLight,
  Sharknado,
  Sync,
  Cog,
} from '@assets/svgs';
import { UserRoles } from '@models/user';

export enum PortalAdminPageName {
  Offering = 'Offering Management',
  Brokerage = 'Brokerage Management',
  User = 'User Management',
  Maintenance = 'Maintenance',
  Alerts = 'Alerts',
  UWMgmt = 'Underwriter Management',
  QuoteSetupPresetManagement = 'Quote Setup Preset Management',
  MoratoriumManagement = 'Moratorium Management',
  AdvancedPortalData = 'Advanced Portal Configuration',
  CatMgmt = 'Cat Management',
  FormsV2Admin = 'FormsV2 Admin',
  SubmissionDrafts = 'Submission Drafts',
  UiPlayground = 'UI Playground',
  BORTransfer = 'BOR Transfer Requests',
  ApiClientManagement = 'API Client Management',
}

export enum PortalAdminAdvancedPortalDataPageName {
  LOIAvailability = 'LOI Availability',
  BrokerageCommission = 'Brokerage Commission Defaults',
  UnderwritingActivityTypes = 'Underwriting Activity Types',
  OfferingDefaultJurisdiction = 'Offering Default Jurisdictions',
  OfferingSubjectivities = 'Subjectivities',
  BusinessClasses = 'Business Classes',
  Coverages = 'Coverages',
  PostRateDefaultFactors = 'Post Rate Default Factors',
  LegalNoticeManagement = 'Legal Notice Management',
}

export const PortalAdminPages = {
  [PortalAdminPageName.Brokerage]: {
    url: 'brokerage-management',
    roles: [
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
      UserRoles.Producer,
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.JrOps,
    ],
  },
  [PortalAdminPageName.User]: {
    url: 'user-management',
    roles: [UserRoles.Producer, UserRoles.SrOps, UserRoles.SystemAdmin, UserRoles.PortalAdmin],
  },
  [PortalAdminPageName.Offering]: {
    url: 'offering-management',
    roles: [
      UserRoles.JrOps,
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminPageName.UWMgmt]: {
    url: 'underwriter-management',
    roles: [
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminPageName.MoratoriumManagement]: {
    url: 'moratorium-management',
    roles: [
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.SrOps,
      UserRoles.JrOps,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminPageName.QuoteSetupPresetManagement]: {
    url: 'url-presets',
    roles: [
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.SrOps,
      UserRoles.JrOps,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminPageName.AdvancedPortalData]: {
    url: 'advanced-portal-configuration',
    roles: [
      UserRoles.JrOps,
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminPageName.Maintenance]: {
    url: 'maintenance',
    roles: [UserRoles.Producer, UserRoles.SystemAdmin, UserRoles.PortalAdmin],
  },
  [PortalAdminPageName.Alerts]: {
    url: 'alerts',
    roles: [UserRoles.Producer, UserRoles.SystemAdmin, UserRoles.PortalAdmin],
  },
  [PortalAdminPageName.CatMgmt]: {
    url: 'daily-cat',
    roles: [],
  },
  [PortalAdminPageName.FormsV2Admin]: {
    url: 'forms-v2-admin',
    roles: [
      UserRoles.JrOps,
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminPageName.SubmissionDrafts]: {
    url: 'submission-drafts',
    roles: [UserRoles.SystemAdmin, UserRoles.PortalAdmin, UserRoles.Underwriter],
  },
  [PortalAdminPageName.UiPlayground]: {
    url: 'ui-playground',
    roles: [UserRoles.SystemAdmin, UserRoles.PortalAdmin],
  },
  [PortalAdminPageName.BORTransfer]: {
    url: 'bor-transfer-requests',
    roles: [UserRoles.SystemAdmin, UserRoles.PortalAdmin],
  },
  [PortalAdminPageName.ApiClientManagement]: {
    url: 'api-client-management',
    roles: [UserRoles.SystemAdmin, UserRoles.PortalAdmin],
  },
  // advanced data pages
  [PortalAdminAdvancedPortalDataPageName.LOIAvailability]: {
    url: 'loi-availability',
    roles: [
      UserRoles.JrOps,
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminAdvancedPortalDataPageName.BrokerageCommission]: {
    url: 'brokerage-commission-defaults',
    roles: [
      UserRoles.JrOps,
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminAdvancedPortalDataPageName.OfferingDefaultJurisdiction]: {
    url: 'offering-default-jurisdictions',
    roles: [
      UserRoles.JrOps,
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminAdvancedPortalDataPageName.OfferingSubjectivities]: {
    url: 'offering-subjectivities',
    roles: [
      UserRoles.JrOps,
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminAdvancedPortalDataPageName.BusinessClasses]: {
    url: 'business-classes',
    roles: [
      UserRoles.JrOps,
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminAdvancedPortalDataPageName.Coverages]: {
    url: 'coverages',
    roles: [
      UserRoles.JrOps,
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminAdvancedPortalDataPageName.PostRateDefaultFactors]: {
    url: 'post-rate-default-factors',
    roles: [
      UserRoles.JrOps,
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminAdvancedPortalDataPageName.LegalNoticeManagement]: {
    url: 'legal-notice-management',
    roles: [
      UserRoles.JrOps,
      UserRoles.SrOps,
      UserRoles.SystemAdmin,
      UserRoles.PortalAdmin,
      UserRoles.Underwriter,
      UserRoles.LIOContractor,
    ],
  },
  [PortalAdminAdvancedPortalDataPageName.UnderwritingActivityTypes]: {
    url: 'underwriting-activity-types',
    roles: [UserRoles.SrOps, UserRoles.SystemAdmin, UserRoles.PortalAdmin, UserRoles.Underwriter],
  },
};

export const drawerListItems = [
  {
    icon: <Tasks />,
    name: PortalAdminPageName.Brokerage,
    roles: PortalAdminPages[PortalAdminPageName.Brokerage].roles,
    path: PortalAdminPages[PortalAdminPageName.Brokerage].url,
  },
  {
    icon: <Users />,
    name: PortalAdminPageName.User,
    roles: PortalAdminPages[PortalAdminPageName.User].roles,
    path: PortalAdminPages[PortalAdminPageName.User].url,
  },
  {
    icon: <FileAlt />,
    name: PortalAdminPageName.Offering,
    roles: PortalAdminPages[PortalAdminPageName.Offering].roles,
    path: PortalAdminPages[PortalAdminPageName.Offering].url,
  },
  {
    icon: <Pen />,
    name: PortalAdminPageName.UWMgmt,
    roles: PortalAdminPages[PortalAdminPageName.UWMgmt].roles,
    path: PortalAdminPages[PortalAdminPageName.UWMgmt].url,
  },
  {
    icon: <Sharknado />,
    name: PortalAdminPageName.MoratoriumManagement,
    roles: PortalAdminPages[PortalAdminPageName.MoratoriumManagement].roles,
    path: PortalAdminPages[PortalAdminPageName.MoratoriumManagement].url,
  },
  {
    icon: <LinkLight />,
    name: PortalAdminPageName.QuoteSetupPresetManagement,
    roles: PortalAdminPages[PortalAdminPageName.QuoteSetupPresetManagement].roles,
    path: PortalAdminPages[PortalAdminPageName.QuoteSetupPresetManagement].url,
  },
  {
    icon: <ListAlt />,
    name: PortalAdminPageName.AdvancedPortalData,
    roles: PortalAdminPages[PortalAdminPageName.AdvancedPortalData].roles,
    path: PortalAdminPages[PortalAdminPageName.AdvancedPortalData].url,
  },
  {
    icon: <Wrench />,
    name: PortalAdminPageName.Maintenance,
    roles: PortalAdminPages[PortalAdminPageName.Maintenance].roles,
    path: PortalAdminPages[PortalAdminPageName.Maintenance].url,
  },
  {
    icon: <ExclamationTriangle />,
    name: PortalAdminPageName.Alerts,
    roles: PortalAdminPages[PortalAdminPageName.Alerts].roles,
    path: PortalAdminPages[PortalAdminPageName.Alerts].url,
  },
  {
    icon: <Cat />,
    name: PortalAdminPageName.CatMgmt,
    roles: PortalAdminPages[PortalAdminPageName.CatMgmt].roles,
    path: PortalAdminPages[PortalAdminPageName.CatMgmt].url,
  },
  {
    icon: <ClipboardList />,
    name: PortalAdminPageName.FormsV2Admin,
    roles: PortalAdminPages[PortalAdminPageName.FormsV2Admin].roles,
    path: PortalAdminPages[PortalAdminPageName.FormsV2Admin].url,
  },
  {
    icon: <SubmissionDraftsSolid />,
    name: PortalAdminPageName.SubmissionDrafts,
    roles: PortalAdminPages[PortalAdminPageName.SubmissionDrafts].roles,
    path: PortalAdminPages[PortalAdminPageName.SubmissionDrafts].url,
  },
  {
    icon: null,
    name: PortalAdminPageName.UiPlayground,
    roles: PortalAdminPages[PortalAdminPageName.UiPlayground].roles,
    path: PortalAdminPages[PortalAdminPageName.UiPlayground].url,
  },
  {
    icon: <Sync />,
    name: PortalAdminPageName.BORTransfer,
    roles: PortalAdminPages[PortalAdminPageName.BORTransfer].roles,
    path: PortalAdminPages[PortalAdminPageName.BORTransfer].url,
  },
  {
    icon: <Cog />,
    name: PortalAdminPageName.ApiClientManagement,
    roles: PortalAdminPages[PortalAdminPageName.ApiClientManagement].roles,
    path: PortalAdminPages[PortalAdminPageName.ApiClientManagement].url,
  },
];
